module.exports = __webpack_public_path__ + "img/mpeg.8c6d24f3.png";